<template>
  <i class="tm-tracks-visual" v-tm-move="moveObj">
    <slot />

    <tm-visual-ghost
      v-if="isDragging"
      :asset="trackInHand.data"
      :point="$data.ghostPoint"
      :mode="$data.mode"
      :isInside="true"
    />
  </i>
</template>

<script>
import { mapState } from 'vuex';
import moveVisualInternalMixin from '../movable/moveVisualInternal';
import tmMove from '../movable/tmMove';
import tmVisualGhost from '../indicator/tmVisualGhost.vue';
import { TimePoint } from '../../api/grid';

export default {
  name: 'tm-tracks-visual',
  mixins: [moveVisualInternalMixin],
  directives: { tmMove },
  components: {
    tmVisualGhost,
  },

  data() {
    return {
      ghostPoint: new TimePoint(),
      mode: null,
    };
  },

  computed: {
    ...mapState('timemachine', {
      trackInHand: (state) => state.dndEscort.trackInHand,
      MODE_VISUAL_DND: (state) => state.MODE.VISUAL_DND,
    }),

    isDragging() {
      return !!this.trackInHand && this.MODE_VISUAL_DND;
    },
  },
};
</script>

<style lang="scss">
.tm-tracks > .tm-tracks-visual {
}
</style>
